import styled from 'styled-components'

import { mainColors } from '../../styles/colors'
import { _M_Normal, _S_Normal } from '../../styles/typography'
import { ellipsis } from '../../styles/utils'

export const Container = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
`

export const Text = styled.div<{ textColor?: string }>`
  ${ellipsis};
  ${_M_Normal};
  color: ${({ textColor }) => textColor || mainColors.black};
  text-align: left;
`

export const SubText = styled.span<{ subTextColor?: string }>`
  ${ellipsis};
  ${_S_Normal};
  color: ${({ subTextColor }) => subTextColor || mainColors.neutralExtremelyDark};
  margin-top: 2px;
  text-align: left;
`
